<template>
  <div style="background: rgb(45 140 240 / 8%); height: 100%">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <div v-show="!shows">
        <h2 style="margin-bottom: 40px">找回密码</h2>
        <el-form-item prop="phone" style="margin: 53px 0">
          <el-input
            :readonly="show"
            v-model.number="ruleForm.phone"
            @focus="show = false"
            placeholder="请输入用户名或手机号"
            maxlength="11"
          >
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-button
          type="primary"
          style="margin: 5px 0 15px 0; width: 100%"
          @click="next()"
        >
          下一步
        </el-button>
      </div>
      <div v-show="shows">
        <h2 style="margin-bottom: 13px">重置密码</h2>
        <p style="margin-bottom: 18px; color: #999">
          请发送验证码到手机 {{ newTel }}
        </p>
        <el-form-item prop="ssmcode" style="text-align: left">
          <div style="display: flex">
            <el-input
              v-model="ruleForm.ssmcode"
              autocomplete="off"
              placeholder="输入验证码"
              style="width: 74%"
            >
            </el-input>
            <el-input
              v-show="false"
              v-model="ruleForm.ssmcodeTT"
              autocomplete="off"
              placeholder="输入验证码"
              style="width: 74%"
            >
            </el-input>
            <span
              v-show="!sendAuthCode"
              style="color: red; font-size: 14px; margin-left: 35px"
              >{{ buttonName }}</span
            >
            <span
              v-show="sendAuthCode"
              @click="getAuthCode()"
              style="
                height: 100%;
                cursor: pointer;
                background: #2d8cf0;
                color: #fff;
                padding: 0 12px;
              "
              >获取验证码</span
            >
          </div>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input
            v-model="ruleForm.passTT"
            autocomplete="new-password"
            show-password
            v-show="false"
            placeholder="请输入重置密码(6-18位数字或英文字符组合)"
          >
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
          <el-input
            v-model="ruleForm.pass"
            autocomplete="new-password"
            show-password
            placeholder="请输入重置密码(6-18位数字或英文字符组合)"
          >
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            placeholder="请确认密码"
            show-password
          >
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <!-- 手机验证吗 -->

        <el-button
          type="primary"
          style="margin: 5px 0 15px 0; width: 100%"
          @click="chongzhis(ruleForm, 'ruleForm')"
        >
          提交
        </el-button>
      </div>
      <p style="position: absolute; top: 20px; right: 15px">
        <span class="fr">已有账户 ?</span>
        <span
          class="fr"
          style="color: #95a0e3; cursor: pointer"
          @click="login_fun(1, true)"
          >直接登录</span
        >
      </p>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    var getName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value.replace(/\s+/g, "") === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("请输入6-18位数字或英文字符组合"));
      } else if (value.length > 18) {
        callback(new Error("请输入6-18位数字或英文字符组合"));
      } else {
        // if (this.ruleForm.checkPass.replace(/\s+/g, "") !== "") {
        //   this.$refs.ruleForm.validateField("checkPass");
        // }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value.replace(/\s+/g, "") === "") {
        callback(new Error("请再次输入密码,不能使用空格"));
        this.nos = false;
      } else if (value.replace(/\s+/g, "") !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
        this.nos = false;
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("填写内容不能为空"));
      } else {
        callback();
      }
    };
    var ssmCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        const reg = /^\d{6}$/;
        // console.log(reg.test(value),"jhfh");
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的验证码"));
        }
      }
    };
    return {
      shows: false,
      second: 60,
      sendAuthCode: true,
      buttonName: "",
      nos: true,
      phones: "",
      show: true,
      newTel: "",
      ruleForm: {
        nickName: "",
        pass: "",
        checkPass: "",
        phone: "",
        ssmcode: "",
        ssmcodeTT: "",
        passTT: "",
      },
      rules: {
        nickName: [
          {
            validator: getName,
            trigger: "blur",
          },
        ],
        pass: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        // 匹配验证码
        ssmcode: [
          {
            validator: ssmCode,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    login_fun() {
      this.$router.push("/");
    },
    getCode() {
      let that = this;
      let interval = window.setInterval(function () {
        that.buttonName = that.second + "s";
        --that.second;
        if (that.second < 0) {
          that.sendAuthCode = true;
          that.second = 60;
          window.clearInterval(interval);
          // that.getCode();
        }
      }, 1000);
    },
    next() {
      if (this.ruleForm.phone == "") {
        this.$message({
          message: "填写内容不能为空！",
          type: "error",
        });
        return;
      }
      this.$axios
        .post(
          "/cmsMateService/login.do?method=achieveBoundPhone",
          {
            str: this.ruleForm.phone,
          }
        )
        .then((res) => {
          if (res.data.result == 200) {
            var tel = res.data.phone;
            this.phones = tel;
            tel = "" + tel;
            this.newTel = tel.replace(tel.substring(3, 7), "****");
            console.log(this.newTel);
            this.shows = true;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
    // 短信接口
    getAuthCode() {
      // this.timeacive();
      this.$axios
        .post(
          "/cmsMateService/login.do?method=achieveSMSCode",
          {
            phone: this.phones,
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.result == 200) {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });
            this.sendAuthCode = false;
            this.second = 60;
            this.getCode();
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
          console.log(res.data.result, "短信");
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
    chongzhis() {
      var pass = this.$md5(this.ruleForm.pass);
      if (this.nos == false) {
        this.$message({
          showClose: true,
          message: "请您再次输入重置密码！",
          type: "error",
        });
        this.ruleForm.checkPass = "";
        return;
      }
      this.$axios
        .post(
          "/cmsMateService/login.do?method=retrievePassword",
          {
            phone: this.phones,
            password: pass.toUpperCase(),
            smsCode: this.ruleForm.ssmcode,
          }
        )
        .then((res) => {
          console.log(res, "注册成功");
          if (res.data.result == 200) {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });
            this.$router.push("/");
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  width: 670px;
  height: 400px;
  position: fixed;
  top: 200px;
  left: 37vw;
  padding: 40px 148px;
  background: #fff;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/reset.vue